import React from "react";
import styles from "./styles/ratingBar.module.css";
import { useTranslation } from "next-i18next";

export function RatingBar({ sizeRatings }) {
  if (!sizeRatings) {
    return null;
  }
  const { t } = useTranslation("reviews");
  const getBackgroundStyle = (rating) => {
    const averageRating = parseFloat(sizeRatings[0]?.toFixed(2));
    const roundedRating = Math.ceil(averageRating);
    return rating === roundedRating ? styles.blackBackground : "";
  };

  const getTitle = () => {
    const averageRating = parseFloat(sizeRatings[0]?.toFixed(2));
    const roundedRating = Math.ceil(averageRating);
    switch (roundedRating) {
      case 1:
        return "runs-small";
      case 2:
        return "runs-slightly-small";
      case 3:
        return "true-to-size";
      case 4:
        return "runs-slightly-large";
      case 5:
        return "runs-large";
      default:
        return "runs-slightly-large";
    }
  };

  return (
    <div>
      <h3 className={styles.title}>{t(getTitle())}</h3>
      <div className={styles["rating-bar"]}>
        <div className={`${styles.bar} ${getBackgroundStyle(1)}`}></div>
        <div className={`${styles.bar} ${getBackgroundStyle(2)}`}></div>
        <div className={`${styles.bar} ${getBackgroundStyle(3)}`}></div>
        <div className={`${styles.bar} ${getBackgroundStyle(4)}`}></div>
        <div className={`${styles.bar} ${getBackgroundStyle(5)}`}></div>
      </div>
      <div className={styles.headings}>
        <p> {t("runs-small")} </p>
        <p> {t("true-to-size")}</p>
        <div>
          <p> {t("runs-large")}</p>
        </div>
      </div>
    </div>
  );
}
